import React, { useState, Fragment, useEffect } from "react";
import {
  Modal,
  Descriptions,
  Form,
  Input,
  message,
  Button,
  Spin,
  Alert,
  Popconfirm,
  Tooltip,
  Divider,
  Typography,
  Tabs,
} from "antd";
// import styles from "../management.module.scss";
import { DeleteOutlined, PlayCircleOutlined, PauseCircleOutlined, ReloadOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "store/hook";
import { CharacterVerify } from "../../../Utility/RegExp";
import { custInfRecordProps } from "../index";
import {
  useDeviceToken,
  useUpdateToken,
  useCreateToken,
  useDeleteToken,
  useOpenapiToken,
  useCreateOpenapiToken,
  useDeleteOpenapiToken,
  useUpdateOpenapiToken,
  useModifyOpenapiToken,
} from "../queries";
import styles from "../management.module.scss";
const { TabPane } = Tabs;

interface schemeProps {
  Tokenvisible: boolean;
  setTokenvisible: (arg: boolean) => void;
  record: custInfRecordProps;
  setRecord: (arg: custInfRecordProps) => void;
}

const { Text } = Typography;

export const TokenModelC = React.memo(({ Tokenvisible, setTokenvisible, record, setRecord }: schemeProps) => {
  const [form_deviceToken] = Form.useForm();
  const [form_openapiToken] = Form.useForm();

  const { t } = useTranslation();
  const { level } = useAppSelector((state) => state.global);
  // Device Token
  const [deviceTokenEditable, setDeviceTokenEditable] = useState(false);
  const { data: deviceTokenList, isFetching: deviceTokenListFetching } = useDeviceToken(record?.cid, Tokenvisible);
  const { mutateAsync: updateTokenMutation, isLoading: updateTokenLoading } = useUpdateToken(record?.cid);
  const { mutateAsync: createTokenMutation, isLoading: createTokenLoading } = useCreateToken(record?.cid);
  const { mutateAsync: deleteTokenMutation, isLoading: deleteTokenLoading } = useDeleteToken(record?.cid);
  const deviceTokenLoading = deviceTokenListFetching || updateTokenLoading || createTokenLoading || deleteTokenLoading;

  // OpenAPI Token
  const [activeTab, setActiveTab] = useState("1");
  const [openapiTokenEditable, setOpenapiTokenEditable] = useState(false);
  const { data: openapiTokenData, isFetching: openapiTokenListFetching } = useOpenapiToken(record?.cid, Tokenvisible);
  const {
    mutateAsync: createOpenapiTokenMutation,
    isLoading: createOpenapiTokenLoading,
    status: createOpenapiTokenStatus,
  } = useCreateOpenapiToken(record?.cid);
  const {
    mutateAsync: modifyOpenapiTokenMutation,
    isLoading: modifyOpenapiTokenLoading,
    status: modifyOpenapiTokenStatus,
  } = useModifyOpenapiToken(record?.cid);
  // const { mutateAsync: deleteOpenapiTokenMutation, isLoading: deleteOpenapiTokenLoading } = useDeleteOpenapiToken(
  //   record?.cid
  // );
  // fastAPI
  const {
    mutateAsync: updateOpenapiTokenMutation,
    isLoading: updateOpenapiTokenLoading,
    status: updateOpenapiTokenStatus,
  } = useUpdateOpenapiToken(record?.cid);
  const openAPITokenLoading =
    openapiTokenListFetching ||
    createOpenapiTokenLoading ||
    modifyOpenapiTokenLoading ||
    // deleteOpenapiTokenLoading ||
    updateOpenapiTokenLoading;

  useEffect(() => {
    const shouldUpdateToken =
      level === "super" &&
      openapiTokenData?.openapi_token &&
      openapiTokenData?.openapi_token !== localStorage.getItem("authUser.openapiToken");

    const hasTokenUpdateStatusSuccess =
      (updateOpenapiTokenStatus === "success" ||
        modifyOpenapiTokenStatus === "success" ||
        createOpenapiTokenStatus === "success") &&
      openapiTokenData?.openapi_token &&
      level === "super";

    if (Tokenvisible && (hasTokenUpdateStatusSuccess || shouldUpdateToken)) {
      localStorage.setItem("authUser.openapiToken", openapiTokenData?.openapi_token);
    }
  }, [
    Tokenvisible,
    openapiTokenData?.openapi_token,
    level,
    updateOpenapiTokenStatus,
    modifyOpenapiTokenStatus,
    createOpenapiTokenStatus,
  ]);

  // form.setFieldsValue({ token: deviceTokenList?.token_list?.[0]?.token + "**" });

  // -------------- Device Token function begin --------------
  const updateToken = (values: any) => {
    let token_list = [];

    if (values.token_list) {
      // enable disable token
      for (let i = 0; i < values.token_list.length; i++) {
        token_list.push({
          old_token: values.token_list[i],
          new_token: values.token_list[i],
          active: values.active,
        });
      }
    } else {
      // edit token
      for (let i = 0; i < values.token.length; i++) {
        if (values.token[i] !== undefined) {
          token_list.push({
            old_token: deviceTokenList?.token_list?.[i]?.token,
            new_token: values.token[i],
            active: deviceTokenList?.token_list?.[i]?.active,
          });
        }
      }
    }
    updateTokenMutation({ values, cid: record.cid, token_list })
      .then(() => {
        message.success(t("ISMS.Success"));
      })
      .catch(() => {
        message.error(t("ISMS.Fail"));
      })
      .finally(() => {
        form_deviceToken.resetFields();
        setDeviceTokenEditable(false);
      });
  };

  const CreateToken = async () => {
    createTokenMutation({ cid: record.cid })
      .then(() => {
        message.success(t("ISMS.Success"));
      })
      .catch(() => {
        message.error(t("ISMS.Fail"));
      });
  };

  const DeleteToken = (item: any) => {
    deleteTokenMutation({ cid: record.cid, item })
      .then(() => {
        message.success(t("ISMS.Success"));
      })
      .catch(() => {
        message.error(t("ISMS.Fail"));
      });
  };

  const tokenList: any = [];
  deviceTokenList?.token_list?.map((item: any) => {
    tokenList.push(item.token);
  });
  // -------------- Device Token function End --------------

  // -------------- OpenAPI Token function begin --------------
  const modifyOpenapiToken = (values: any) => {
    modifyOpenapiTokenMutation({ values, cid: record.cid, openapi_token: values?.openapi_token })
      .then(() => {
        message.success(t("ISMS.OpenAPI Token modified successfully!"));
      })
      .catch(() => {
        message.error(t("ISMS.Modify OpenAPI Token Failed!"));
      })
      .finally(() => {
        form_openapiToken.resetFields();
        setOpenapiTokenEditable(false);
      });
  };

  const CreateOpenapiToken = async () => {
    createOpenapiTokenMutation({ cid: record.cid })
      .then(() => {
        message.success(t("ISMS.Success"));
      })
      .catch(() => {
        message.error(t("ISMS.Fail"));
      });
  };

  const UpdateOpenapiToken = async () => {
    try {
      await updateOpenapiTokenMutation(); // 呼叫你自定義的更新 token API
      message.success(t("ISMS.OpenAPI Token updated successfully!"));
    } catch (err) {
      message.error(t("ISMS.Update OpenAPI Token Failed!")); // 顯示具體錯誤
    }
  };
  // TODO: OpenAPI 暫時不提供刪除功能，刪除會造成前端無法呼叫 OpenAPI
  // const DeleteOpenapiToken = (item: any) => {
  //   deleteOpenapiTokenMutation({ cid: record.cid, item })
  //     .then(() => {
  //       message.success(t("ISMS.Success"));
  //     })
  //     .catch(() => {
  //       message.error(t("ISMS.Fail"));
  //     });
  // };
  // const tokenList: any = [];
  // deviceTokenList?.token_list?.map((item: any) => {
  //   tokenList.push(item.token);
  // });
  // -------------- OpenAPI Token function End --------------

  return (
    <Modal
      visible={Tokenvisible}
      onCancel={() => {
        setTokenvisible(false);
        setRecord({ cid: undefined });
        // apiform.resetFields();
        setActiveTab("1");
        setOpenapiTokenEditable(false);
        setDeviceTokenEditable(false);
      }}
      centered={true}
      // className={`${styles.modal}}
      destroyOnClose={true}
      title={t("ISMS.KeyManagement")}
      footer={
        activeTab === "1"
          ? [
              deviceTokenEditable ? (
                <Button
                  key="Submit"
                  type="primary"
                  loading={deviceTokenLoading}
                  onClick={() => {
                    form_deviceToken.submit();
                  }}
                >
                  {t("ISMS.Submit")}
                </Button>
              ) : (
                !deviceTokenEditable && (
                  <Button
                    key="Confirm"
                    type="primary"
                    loading={deviceTokenLoading}
                    onClick={() => {
                      setTokenvisible(false);
                    }}
                  >
                    {t("ISMS.Confirm")}
                  </Button>
                )
              ),
            ]
          : [
              openapiTokenEditable ? (
                <Popconfirm
                  title={
                    <>
                      <p>{t("ISMS.Sure to Modify Token?")}</p>
                      <p>{t("ISMS.TokenModifyInvalidatesAPI")}</p>
                    </>
                  }
                  okText={t("ISMS.OK")}
                  cancelText={t("ISMS.Cancel")}
                  onConfirm={() => {
                    form_openapiToken.submit();
                  }}
                >
                  <Button loading={openAPITokenLoading} key="Submit" type="primary">
                    {t("ISMS.Submit")}
                  </Button>
                </Popconfirm>
              ) : (
                // <Button
                //   key="Submit"
                //   type="primary"
                //   loading={openAPITokenLoading}
                //   onClick={() => {
                //     form_openapiToken.submit();
                //   }}
                // >
                //   {t("ISMS.Submit")}
                // </Button>
                !openapiTokenEditable && (
                  <Button
                    key="Confirm"
                    type="primary"
                    loading={openAPITokenLoading}
                    onClick={() => {
                      setTokenvisible(false);
                    }}
                  >
                    {t("ISMS.Confirm")}
                  </Button>
                )
              ),
            ]
      }
    >
      <Tabs
        type="card"
        defaultActiveKey="1"
        destroyInactiveTabPane={false}
        onChange={(key) => {
          setDeviceTokenEditable(false);
          setOpenapiTokenEditable(false);
          setActiveTab(key);
        }}
        activeKey={activeTab}
      >
        <TabPane
          // tab="Create User"
          tab={t("ISMS.DeviceToken")}
          key="1"
          forceRender={true}
          style={{ marginTop: "12px" }}
        >
          {!deviceTokenLoading ? (
            <Fragment>
              <Fragment key="123">
                {(level === "super_super" || level === "super") && (
                  <Button
                    key="Edit"
                    loading={deviceTokenLoading}
                    onClick={() => {
                      setDeviceTokenEditable(!deviceTokenEditable);
                      form_deviceToken.setFieldsValue({ token: tokenList });
                    }}
                    style={{ marginRight: "5px", marginBottom: "10px" }}
                    disabled={!deviceTokenList?.token_list?.length}
                  >
                    {deviceTokenEditable ? t("ISMS.Cancel") : t("ISMS.Edit")}
                  </Button>
                )}

                {/* FIXME: enable or disable all token */}
                {/* {deviceTokenList?.active === undefined || deviceTokenList?.active ? (
              <Button
                disabled={Editable ? true : false}
                onClick={() => {
                  updateToken({ cid: record.cid, token_list: tokenList, active: false });
                }}
              >
                {t("ISMS.Disable") + " " + t("ISMS.Token")}
              </Button>
            ) : (
              <Button
                disabled={Editable ? true : false}
                onClick={() => {
                  EnableToken(deviceTokenList.cid, true);
                }}
              >
                {t("ISMS.Enable") + " " + t("ISMS.Token")}
              </Button>
            )} */}

                {!deviceTokenEditable && level === "super_super" && deviceTokenList?.token_list?.length < 1 && (
                  <Button
                    key="Create"
                    loading={deviceTokenLoading}
                    onClick={() => {
                      CreateToken();
                    }}
                    // disabled={deviceTokenList?.length > 0 || false}
                  >
                    {t("ISMS.Create")}
                  </Button>
                )}
              </Fragment>
              <Form onFinish={updateToken} form={form_deviceToken} layout="vertical">
                <Descriptions bordered className={styles.desc}>
                  <Descriptions.Item label={t("ISMS.Token")}>
                    {deviceTokenList?.token_list?.map((item: any, index: number) => {
                      return deviceTokenEditable ? (
                        <Form.Item
                          name={["token", index]}
                          key={index}
                          rules={[{ required: true, message: "Token is required!" }, CharacterVerify]}
                        >
                          <Input maxLength={36} />
                        </Form.Item>
                      ) : (
                        <Fragment key={index}>
                          <>
                            <Text
                              copyable={{
                                tooltips: ["Copy Token", "Copied"],
                              }}
                              style={{ marginRight: "8px" }}
                            >
                              {item.token}
                            </Text>
                            {level === "super_super" && (
                              <>
                                {item.active ? (
                                  <Tooltip title={t("ISMS.Disable") + " " + t("ISMS.Token")}>
                                    <Button
                                      icon={<PauseCircleOutlined />}
                                      type="text"
                                      onClick={() => {
                                        updateToken({ cid: record.cid, token_list: [item.token], active: false });
                                      }}
                                    ></Button>
                                  </Tooltip>
                                ) : (
                                  <Tooltip title={t("ISMS.Enable") + " " + t("ISMS.Token")}>
                                    <Button
                                      icon={<PlayCircleOutlined />}
                                      type="text"
                                      onClick={() => {
                                        updateToken({ cid: record.cid, token_list: [item.token], active: true });
                                      }}
                                    ></Button>
                                  </Tooltip>
                                )}

                                <Tooltip title={t("ISMS.Delete Token")}>
                                  <Popconfirm
                                    title={t("ISMS.Sure to delete?")}
                                    okText={t("ISMS.OK")}
                                    cancelText={t("ISMS.Cancel")}
                                    onConfirm={() => {
                                      DeleteToken(item.token);
                                    }}
                                  >
                                    <Button icon={<DeleteOutlined />} type="text"></Button>
                                  </Popconfirm>
                                </Tooltip>
                              </>
                            )}
                          </>
                          {index !== deviceTokenList?.token_list?.length - 1 && <Divider style={{ margin: "5px" }} />}
                        </Fragment>
                      );
                    })}
                  </Descriptions.Item>
                </Descriptions>
              </Form>
            </Fragment>
          ) : (
            <Spin tip="Loading...">
              <Alert
                message="Getting Data"
                description="We are now getting data from server, please wait for a few seconds"
              />
            </Spin>
          )}
        </TabPane>
        <TabPane
          // tab="Create User"
          tab={t("ISMS.OpenAPIToken")}
          key="2"
          forceRender={true}
          style={{ marginTop: "12px" }}
        >
          {!openAPITokenLoading ? (
            <Fragment key="OpenAPIToken_1">
              <Fragment key="OpenAPIToken_2">
                {(level === "super_super" || level === "super") && (
                  <Button
                    key="Edit"
                    loading={openAPITokenLoading}
                    onClick={() => {
                      setOpenapiTokenEditable(!openapiTokenEditable);
                      form_openapiToken.setFieldsValue({ openapi_token: openapiTokenData?.openapi_token });
                    }}
                    style={{ marginRight: "5px", marginBottom: "10px" }}
                    disabled={!openapiTokenData?.openapi_token}
                  >
                    {openapiTokenEditable ? t("ISMS.Cancel") : t("ISMS.Edit")}
                  </Button>
                )}

                {!openapiTokenEditable && level === "super_super" && !openapiTokenData?.openapi_token && (
                  <Button
                    key="Create"
                    loading={openAPITokenLoading}
                    onClick={() => {
                      CreateOpenapiToken();
                    }}
                    // disabled={deviceTokenList?.length > 0 || false}
                  >
                    {t("ISMS.Create")}
                  </Button>
                )}
              </Fragment>
              <Form onFinish={modifyOpenapiToken} form={form_openapiToken} layout="vertical">
                <Descriptions bordered className={styles.desc}>
                  <Descriptions.Item label={t("ISMS.Token")}>
                    {openapiTokenEditable ? (
                      <Form.Item
                        name={"openapi_token"}
                        rules={[{ required: true, message: "Token is required!" }, CharacterVerify]}
                      >
                        <Input />
                      </Form.Item>
                    ) : (
                      <Fragment>
                        {openapiTokenData?.openapi_token && (
                          <>
                            <div>
                              <Text
                                copyable={{
                                  tooltips: ["Copy Token", "Copied"],
                                }}
                                style={{ marginRight: "8px" }}
                              >
                                {openapiTokenData?.openapi_token}
                              </Text>
                              {(level === "super_super" || level === "super") && (
                                <>
                                  <Tooltip title={t("ISMS.Update OpenAPI Token")}>
                                    <Popconfirm
                                      title={
                                        <>
                                          <p>{t("ISMS.Sure to Update Token?")}</p>
                                          <p>{t("ISMS.TokenUpdateInvalidatesAPI")}</p>
                                        </>
                                      }
                                      okText={t("ISMS.OK")}
                                      cancelText={t("ISMS.Cancel")}
                                      onConfirm={UpdateOpenapiToken}
                                    >
                                      <Button icon={<ReloadOutlined />} type="text"></Button>
                                    </Popconfirm>
                                  </Tooltip>
                                </>
                              )}
                            </div>
                          </>
                        )}
                      </Fragment>
                    )}
                  </Descriptions.Item>
                </Descriptions>
              </Form>
            </Fragment>
          ) : (
            <Spin tip="Loading...">
              <Alert
                message="Getting Data"
                description="We are now getting data from server, please wait for a few seconds"
              />
            </Spin>
          )}
        </TabPane>
      </Tabs>
    </Modal>
  );
});
